<template>
  <div>
    <BForm
      class="formulario"
      @submit.prevent="gravar">

      <BFormCheckbox
        class="input__ativo"
        v-model="form.status">
        Usuário ativo
      </BFormCheckbox>

      <InputBasico
        ref="inputNome"
        type="text"
        name="nomeInput"
        label="Nome*"
        class="input__nome"
        v-model="form.nome"
        v-validate="'required|min:3'"
        :errorsBag="errors" />

      <InputCargo
        name="inputCargo"
        label="Cargo*"
        class="input__cargo"
        v-model="form.cargo"
        v-validate="'required'"
        :errorsBag="errors" />

      <InputBasico
        type="text"
        name="usuarioInput"
        label="Usuário*"
        class="input__usuario"
        v-model="form.usuario"
        v-validate="'required|min:3'"
        :lowerCase="true"
        :errorsBag="errors"
        :disabled="!novoRegistro" />

      <InputBasico
        type="email"
        name="emailInput"
        label="E-mail"
        class="input__email"
        v-model="form.email"
        :errorsBag="errors" />

      <InputSugestaoFilial
        label="Filial"
        name="inputFilial"
        class="input__filial"
        v-model="form.filial"
        v-validate="'required'"
        :errorsBag="errors" />

      <InputCelular
        name="whatsInput"
        label="WhatsApp"
        class="input__whats"
        v-model="form.whatsapp"
        v-validate="'minLenTel'"
        :errorsBag="errors" />

      <BButton
        variant="primary"
        class="input__botaoAdicionar"
        @click.prevent="abrirModalHoras">
        Adicionar
      </BButton>
      <BTable
        v-if="form.horarioTrabalho.length > 0"
        stacked="sm"
        striped
        :items="form.horarioTrabalho"
        :fields="camposTabela"
        class="tabela__horarios">

        <template
          :slot="'horaInicial'"
          slot-scope="data">
          {{ data.value| formatTime }}
        </template>

        <template
          :slot="'horaFinal'"
          slot-scope="data">
          {{ data.value | formatTime }}
        </template>

        <template
          :slot="'dia'"
          slot-scope="data">
          {{ data.value.descricao }}
        </template>

        <template
          :slot="'percentual'"
          slot-scope="data">
          {{ data.value }}%
        </template>

        <template
          slot="deletar"
          slot-scope="data">
          <b-button
            class="botaoRemover"
            size="sm"
            @click="removerHorario(data.index)"
            variant="danger">
            X
          </b-button>
        </template>
      </BTable>

      <div class="botao__container">
        <BButton
          v-if="!novoRegistro"
          @click.prevent="resetarSenha"
          class="botao"
          variant="light">
          Resetar senha
        </BButton>

        <BButton
          type="submit"
          class="botao"
          variant="primary">
          Gravar
        </BButton>

        <BButton
          @click.prevent="sair"
          class="botao"
          variant="outline-primary">
          Sair
        </BButton>
      </div>
    </BForm>
    <UsuariosHorasCadastroModal
      :horarios="form.horarioTrabalho"
      ref="modalHoras" />

    <ModalConfirmacao
      ref="modalConfirmacao"
      :titulo="dialog.titulo"
      :mensagem="dialog.mensagem" />
  </div>
</template>

<script>
import _ from 'lodash'
import {
  BForm, BFormCheckbox, BButton, BTable,
} from 'bootstrap-vue/es/components'
import ModalConfirmacao from '@/components/modal/ModalConfirmacao.vue'
import FormularioCadastroMixin from '@/mixins/FormularioCadastroMixin'
import UsuariosHorasCadastroModal from './UsuariosHorasCadastroModal.vue'
import InputBasico from '@/components/inputs/InputBasico.vue'
import InputCelular from '@/components/inputs/pessoais/InputCelular.vue'
import InputCargo from '../../../components/inputs/InputCargo.vue'
import InputSugestaoFilial from '../../../components/inputs/sugestao/InputSugestaoFilial.vue'

import * as dataUtils from '@/utils/data.utils'

export default {
  name: 'UsuariosCadastroForm',
  mixins: [FormularioCadastroMixin],
  components: {
    BForm,
    BFormCheckbox,
    BButton,
    BTable,
    UsuariosHorasCadastroModal,
    InputBasico,
    InputCelular,
    InputCargo,
    InputSugestaoFilial,
    ModalConfirmacao,
  },
  mounted() {
    this.$refs.inputNome.focar()
  },
  data() {
    return {
      camposTabela: this.retornaCamposMostrarTabela(),
      dialog: {
        titulo: '',
        mensagem: '',
      },
    }
  },
  methods: {
    valoresIniciaisForm() {
      return {
        status: true,
        nome: '',
        cargo: 'barbeiro',
        usuario: '',
        email: '',
        filial: null,
        whatsapp: '',
        horarioTrabalho: [],
      }
    },
    retornaCamposGravar() {
      if (!this.novoRegistro) {
        return _.omit(this.form, ['usuario', 'password'])
      }

      return this.form
    },
    retornaCamposMostrarTabela() {
      return [
        { key: 'dia', label: 'Dia' },
        { key: 'horaInicial', label: 'Horário inicial' },
        { key: 'horaFinal', label: 'Horário final' },
        { key: 'percentual', label: 'Percentual' },
        { key: 'deletar', label: '' },
      ]
    },
    abrirModalHoras() {
      this.$refs.modalHoras.pop()
        .then(res => {
          if (res) {
            const arrConcat = this.form.horarioTrabalho.concat(res)
            const arrOrdenaPorDia = _
              .orderBy(arrConcat, item => item.dia.diaDaSemana)

            const arrOrdenaPorHora = arrOrdenaPorDia.sort((a, b) => {
              if (a.dia.diaDaSemana === b.dia.diaDaSemana) {
                if (dataUtils.paraDate(a.horaFinal) < dataUtils.paraDate(b.horaInicial)) {
                  return -1
                }

                return 1
              }
              return 0
            })

            this.form.horarioTrabalho = arrOrdenaPorHora
          }
        })
    },
    removerHorario(indice) {
      this.form.horarioTrabalho.splice(indice, 1)
    },
    async resetarSenha() {
      this.dialog.titulo = 'Resetar senha'
      this.dialog.mensagem = 'Você tem certeza que deseja RESETAR a senha do usuário?'

      const podeCancelar = await this.$refs.modalConfirmacao.pop()
      if (podeCancelar) {
        this.$emit('resetarSenha', this.retornaCamposGravar())
      }
    },
  },
}

</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

.formulario {
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: $small-size) {
    width: 100%;
    grid-template-columns: repeat(12, 1fr);
    grid-column-gap: 0.8em;
  }

  @media (min-width: $extra-large-size) {
    width: $medium-size;
  }
}

.input {
  &__ativo {
    @media (min-width: $small-size) {
      grid-column: 1 / 4;
    }
  }

  &__nome {
    @media (min-width: $small-size) {
      grid-column: 1 / -1;
    }

    @media (min-width: $medium-size) {
      grid-column: 1 / 9;
    }
  }

  &__cargo {
    @media (min-width: $small-size) {
      grid-column: 1 / 6;
    }

    @media (min-width: $medium-size) {
      grid-column: 9 / -1;
    }
  }

  &__usuario {
    @media (min-width: $small-size) {
      grid-column: 6 / -1;
    }

    @media (min-width: $medium-size) {
      grid-column: 1 / 6;
    }
  }

  &__email {
    @media (min-width: $small-size) {
      grid-column: 1 / 8;
    }

    @media (min-width: $medium-size) {
      grid-column: 6 / -1;
    }
  }

  &__filial {
    @media (min-width: $small-size) {
      grid-column: 8 / -1;
    }

    @media (min-width: $medium-size) {
      grid-column: 1 / 9;
    }
  }

  &__whats {
    @media (min-width: $small-size) {
      grid-column: 1 / 5;
    }

    @media (min-width: $medium-size) {
      grid-column: 9 / -1;
    }
  }

  &__botaoAdicionar {
    @media (min-width: $small-size) {
      grid-column: 10 / -1;
    }
  }
}

.tabela__horarios {
  @media (min-width: $small-size) {
    grid-column: 1 / -1;
  }
}

.botao {
  margin-left: .2rem;

  &__container {
    margin-top: 1rem;
    grid-column: 1 / -1;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
  }
}

</style>
